const virtualizationStyleProps = {
  position: true,
  top: true,
  left: true,
  width: true,
  transform: true
};
export function filterVirtualizationStyles(style) {
  if (!style) {
    return {
      virtualizationStyles: {},
      restStyles: {}
    };
  }
  const virtualizationStyles = {};
  const restStyles = {};
  Object.keys(style).forEach(key => {
    if (virtualizationStyleProps[key]) {
      virtualizationStyles[key] = style[key];
    } else {
      restStyles[key] = style[key];
    }
  });
  return {
    virtualizationStyles,
    restStyles
  };
}